const tabs = () => {
	const tabs = document.querySelectorAll('.single-product__tabs');

	const changeTab = (index, buttons, contents) => {
		buttons.forEach(btn => {
			btn.classList.remove('active');
		});

		contents.forEach(content => {
			content.classList.remove('active');
		});

		console.log(index)

		contents[index].classList.add('active');
		buttons[index].classList.add('active');
	};

	if (tabs) {
		tabs.forEach(tab => {
			const tabButtons = tab.querySelectorAll('.single-product__tabs--button'),
				tabContent = tab.querySelectorAll('.single-product__tabs--content');

			tabButtons.forEach((btn, i) => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();

					changeTab(i, tabButtons, tabContent);
				});
			});
		})
	}
};

const initSizeLine = () => {
	const valueElement = document.querySelector('.single-product__size-guide--value');

	if (valueElement) {
		const value = +valueElement.dataset.value;

		if (value && value > 0 && value < 100) {
			valueElement.style.left = `${value}%`;
		} else {
			valueElement.style.left = `0%`;
		}
	}
};

const initMediaPreview = () => {
	const medias = document.querySelectorAll('.image-preview');
	const image = document.querySelector('.image-container');
	var options = {
		width: 572,
		height: 784,
		offset: {
			vertical: 0,
			horizontal: 10,
			scale: 2.
		},
	}
	let zoom = new ImageZoom(document.getElementById("imgContainer"), options);
	if (medias) {
		for (let index = 0; index < medias.length; index++) {
			const media = medias[index];

			media.addEventListener("click", (e) => {
				zoom.kill()
				const refreshZoomEvent = new Event('refreshZoom');

				image.src = e.target.getAttribute('data-large-url') || e.target.src
				image.srcset = e.target.srcset
				var options = {
					width: 572,
					height: 784,
					oomWidth: 500,
					offset: {
						vertical: 0,
						horizontal: 10,
						scale: 2.
					},
				}
				zoom = new ImageZoom(document.getElementById("imgContainer"), options);

				document.dispatchEvent(refreshZoomEvent);


			})
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	tabs()
	initSizeLine();
	initMediaPreview();
});